import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box, Backdrop } from '@mui/material';
import { Spinner } from '/@/app/components/Spinner';

export const PanelCalculatingView = observer(({ userFlowState }) => {
    const { t } = useTranslation();
    return (
        <Backdrop
            open={true}
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                display: "flex",
                flexFlow: "column wrap",
                gap: 3,
                alignItems: "center",
            }}
        >
            {userFlowState.calculationProgress !== null &&
                <>
                    {userFlowState.calculationProgress === "finished" ?
                        <Box>{t("Готово")} !</Box>
                        :
                        <Box>{t("Пересчитываем результаты")} ...</Box>
                    }
                    <Spinner sx={{ color: "white" }} />
                </>
            }
        </Backdrop>
    )
});
